export default {"src":"/_next/static/media/XLSM.2d449f5f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};